import client from '@/Apollo';
import {
  GetCepAvailability,
  GetDeliveryCepAvailability,
} from '../graphql/query/GetCepAvailability';

export function checkCep(zipCode) {
  const clearedZipCode = String(zipCode).replace(/[^0-9]/gm, '');
  return new Promise((resolve, reject) => {
    client
      .query({ query: GetCepAvailability, variables: { cep: clearedZipCode } })
      .then(({ data: { ReparafoneValidateCepAvailability } }) => {
        const collect = ReparafoneValidateCepAvailability.slice().pop();
        resolve(!!collect);
      })
      .catch((e) => reject(e));
  });
}

export function checkDeliveryCep(zipCode) {
  const clearedZipCode = String(zipCode).replace(/[^0-9]/gm, '');
  return new Promise((resolve, reject) => {
    client
      .query({ query: GetDeliveryCepAvailability, variables: { cep: clearedZipCode } })
      .then(({ data: { ReparafoneValidateDeliveryCepAvailability } }) => {
        const delivery = ReparafoneValidateDeliveryCepAvailability.slice().pop();
        resolve(!!delivery);
      })
      .catch((e) => reject(e));
  });
}
